import ColouredTextPlugin from './ColouredTextPlugin';
export default ColouredTextPlugin;